<template>
  <div style="height: 100%;">
    <my-header :left-click="back">
      开合跳
    </my-header>
    <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
    <div style="position: relative;">
      <div style="position: absolute; display: block; text-align: right; float: right; width: 100%;">
        <van-image :src="stopImage"  width="50" height="50" @click="over"></van-image>
      </div>
      <canvas
          class="output_canvas"
          ref="output_canvas"
          :width="width"
          :height="height"
      />
    </div>
    <van-popup v-model="overShow" title="标题" style="width: 100%; height: 100%;">
      <div class="over-popup" :style="{backgroundImage:`url(${overImage})`}">
        <p class="counter">{{ this.squats.counter }}个</p>
        <van-button class="over-button" size="large" type="info" round @click="back">结束运动</van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Pose, POSE_CONNECTIONS } from "@mediapipe/pose";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col, Popup, Image as VanImage, Dialog, Icon } from 'vant'
import { checkBigCharPose } from '@/utils/mediapipe'

export default {
name: "poseBigChar",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [VanImage.name]: VanImage,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      overShow: false,
      handsImage: '',
      squats: {
        threshold: 0,
        counter: 0,
      },
      stopImage: require('@/assets/css/stop.png'),
      overImage: require('@/assets/css/over.png')
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.init();
    // const agent = calcAgentBy3DPoint({x: 0, y: 0, z: 0}, {x: 1, y: 0, z: 0}, {x: 0, y: -1, z: 0})
    // console.log('agent: '+ agent)
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.pose);
    },
    pose() {
      const pose = new Pose({
        locateFile: (file) => {
          console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/pose@0.5.1635988162/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1635988162/${file}`;
        },
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: true,
        smoothSegmentation: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(this.onResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          await pose.send({ image: this.inputVideo });
        },
        facingMode: this.$store.getters.facingMode,
        width: this.$store.getters.cameraRP.width,
      });
      this.camera.start();
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);
      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      if (results.poseWorldLandmarks) {

        checkBigCharPose(results.poseWorldLandmarks, this.squats.threshold).then(res => {
          if(this.squats.threshold === 0){
            this.squats.counter = this.squats.counter + 0.5
            this.squats.threshold = 2
          }else if(this.squats.threshold === 2){
            this.squats.counter = this.squats.counter + 0.5
            this.squats.threshold = 0
          }
          console.log(res)
        }).catch(err => {
          console.log(err)
        })

        drawConnectors(this.ctx, results.poseLandmarks, POSE_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 4,
        });
        drawLandmarks(this.ctx, results.poseLandmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
        // }
      }
      this.ctx.restore();
      this.ctx.font = '50px STheiti, SimHei'
      this.ctx.fillStyle = "green"
      this.ctx.fillText(this.squats.counter, 30, 100, 200)
    },
    over() {
      this.overShow = true
    },
    back() {
      this.$router.push({ path: '/exercise/types', query: { type: 1 } })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.title{
  font-size: 3rem;
  font-weight: bold;
  text-align: left;
  margin-left: 20px;
}
.counter{
  margin-top: 100%;
  font-size: 3rem;
  font-weight: bold;
  color: #194ea7;
}
.over-popup{
  position: absolute;
  width: 100%;
  text-align: center;
  background-size: 100%;
  background-repeat: no-repeat;
  height: 100%;
}
.over-button{
  font-size: 2rem;
  font-weight: bold;
  width: 50%;
}
</style>
